import styled from 'styled-components';

export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: ${({ $inverted }) => ($inverted ? 'var(--on-night)' : 'var(--ink)')};

  > span:first-child {
    background: ${({ $inverted }) => ($inverted ? 'var(--on-night)' : 'var(--ink)')};
    color: ${({ $inverted }) => ($inverted ? 'var(--ink)' : 'var(--bg)')};
  }
`;

export const Mark = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 800;
  font-size: 21px;
  letter-spacing: -0.04em;
  transition: transform 0.3s var(--ease);

  em {
    color: var(--accent);
    font-style: italic;
  }

  a:hover & {
    transform: rotate(-6deg) scale(1.04);
  }
`;

export const Word = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 1;

  strong {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: 21px;
    letter-spacing: -0.03em;
  }

  span {
    margin-top: 4px;
    font-family: var(--font-mono);
    font-size: 10px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    opacity: 0.6;
  }

  @media (max-width: 520px) {
    display: none;
  }
`;
